<template>
    <div>
        <validation-observer ref="radioFormQuetion">
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <input type="hidden" :value="id" name="questions[]">
                    <div v-if="question" class="radio-btn-attribute">
                        <label :for="id" :class="{' col-md-3 col-xs-4 ' : isInquiry , 'attribute-label' : !isInquiry}" >
                            {{ question.question_text }}
                        </label>
                        <!--  :checked="value && selected && selected.attribute_value_id == value.attribute_value_id"-->
                        <div :class="{' col-md-9 col-xs-8' : isInquiry}">

                            <div v-for="(option,index) of question.options" :key="index">
                                <input :id="id+'-'+option.id"
                                       :name="name"
                                       type="radio"
                                       :checked="isSelected(option)"
                                       @input="check(option)"/>

                                <label :for="id+'-'+option.id"  :class="{'selected': isSelected(option)}">
                                    {{ option.option }}
                                </label>
                            </div>
                            <validation-provider v-slot="{ errors }" :rules="question.mandatory ? 'required' : ''">
                                <div v-if="selected && selected.hasOwnProperty('id')" class="display-none">
                                    <input :id="id+'-'+selected.id" :name="name" :value="selected.id" type="hidden">
                                </div>
                                <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                            </validation-provider>

                        </div>
                    </div>
                <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
            </div>
        </validation-observer>
    </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormRadioButton",
    props: {
        value: {
            type: Object,
            default() {
                return {}
            }
        },
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            question: this.value,
            selected: []
        }
    },
    computed: {
        /**
         * gets all dependencies of the selected question
         * @returns {T[]|*[]}
         */
        dependency() {
            return []
        },
        /**
         * get question input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                    if(this.$refs.radioFormQuetion) {
                        verify(await this.$refs.radioFormQuetion.validate())
                    }
            })
        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        /**
         * pick a value
         * @param value
         */
        uncheck() {
            this.question.value = null
        },
        check(option) {
            this.question.value = option
            this.selected = option
            this.question.answer_text = this.selected
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry( option.id, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        },

        // isSelected(option){
        //     if(this.question.answer_text){
        //         if(this.question.answer_text == option.id){
        //             return true;
        //         }
        //     }else{
        //
        //         if(this.question.value == option.id){
        //             return true;
        //         }
        //     }
        //
        // }
        isSelected(option) {
            if (this.question.answer_text && this.question.answer_text == option.id) {
                this.selected = option
                return true;
            } else if (this.question.value && this.question.value == option.id) {
                return true;
            } else {
                return false; // Return false by default when no condition matches
            }
        }

    },
    mounted() {
        this.addEventListeners()
    },
    watch: {
        question: {
            handler: function (question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners()
    }
}
</script>

<style scoped>
.selected {
    font-weight: bold;
}
.p-0-1{
    padding:0px 1px;
}


@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
        /*margin-left: 15px !important;*/
    }

}

@media screen and (min-width: 1px) and (max-width: 428px) {
    /*@media only screen and (max-width: 428px) {*/
    .change-form-list-in-inquiry {
        width: 57%;
        /*margin-left: 15px !important;*/
    }

}


</style>